var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRoundLoader(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    style: {
      margin: "auto",
      background: "rgba(221, 221, 221, 0)",
      display: "block"
    },
    width: "200px",
    height: "200px",
    viewBox: "0 0 100 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("mask", {
    id: "ldio-kbkbsn6d8eg-mask"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 39,
    stroke: "#fff",
    strokeLinecap: "round",
    strokeDasharray: "183.7831702350029 61.261056745000964",
    strokeWidth: 7
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "rotate",
    values: "0 50 50;360 50 50",
    times: "0;1",
    dur: "0.7246376811594202s",
    repeatCount: "indefinite"
  }))))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#ldio-kbkbsn6d8eg-mask)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 3.5,
    y: 0,
    width: 93,
    height: 100,
    fill: "#ffffff"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "fill",
    values: "#ffffff",
    times: 0,
    dur: "0.7246376811594202s",
    repeatCount: "indefinite",
    begin: "0s"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRoundLoader);
export default __webpack_public_path__ + "static/media/round-loader.abb68e26d64824380e828c2febff80b7.svg";
export { ForwardRef as ReactComponent };